const C = require("../constants");

const selectClient = (data) => {
    return {
        type: C.SELECT_CLIENT,
        data
    }
};

export {selectClient};


// WEBPACK FOOTER //
// ./src/actions/ClientSelectActions.js